module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#f5a000","theme_color":"#f5a000","display":"minimal-ui","icon":"/opt/build/repo/src/assets/img/bamx-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"df3bbb280867ce80084ecc4b9a528117"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
